<template>
  <div class="myTable">

    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
<!--          <div class="search-item">-->
<!--            <span class="label">ICCID：</span>-->
<!--            <el-input v-model="searchInfo.iccid" clearable placeholder="请输入"></el-input>-->
<!--          </div>-->
          <div class="search-item">
            <span class="label">设备号：</span>
            <el-input v-model="searchInfo.imei" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">设备类型：</span>
            <el-input v-model="searchInfo.type" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">探头数：</span>
            <el-input v-model="searchInfo.probeCount" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">电量：</span>
            <el-input v-model="searchInfo.power" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">设备状态：</span>
            <el-select v-model="searchInfo.deviceStatus" clearable style="width: 80px;" placeholder="请选择">
              <el-option
                      v-for="(item, i) in deviceStatusList"
                      :key="i"
                      :label="item.value"
                      :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">创建时间：</span>
            <el-date-picker
                    v-model="createDateArr"
                    style="width: 250px;"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
            </el-date-picker>
          </div>
          <div class="search-item">
            <span class="label">更新时间：</span>
            <el-date-picker
                    v-model="searchDateArr"
                    style="width: 250px;"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
            </el-date-picker>
          </div>

        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px"  @row-dblclick="handleRowDblClick">
        <el-table-column
                type="index"
                width="50">
        </el-table-column>
        <el-table-column prop="imei" label="设备号"width="130"></el-table-column>
        <el-table-column prop="type" label="设备类型"></el-table-column>
        <el-table-column prop="probeCount" label="探头数量"></el-table-column>
        <el-table-column prop="inUseNum" label="在用探头"></el-table-column>
        <el-table-column prop="configuredReportTime" label="设置定时"></el-table-column>
        <el-table-column prop="power" label="电量"></el-table-column>
        <el-table-column prop="deviceStatus" label="设备状态"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="100"></el-table-column>
        <el-table-column prop="dataTraffic" label="流量"></el-table-column>
        <el-table-column prop="defaultReportTime" label="默认时间"></el-table-column>
        <el-table-column prop="location" label="归宿地"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="90"></el-table-column>
        <el-table-column prop="productModel" label="主板型号"></el-table-column>
        <!--        <el-table-column prop="serialPortNum" label="探头数量"></el-table-column>-->
<!--        <el-table-column prop="unUsedNum" label="未用探头"></el-table-column>-->
        <el-table-column prop="softVersion" label="固件版本"></el-table-column>
        <el-table-column prop="bts" label="bts" width="120"></el-table-column>
        <el-table-column prop="iccid" label="ICCID" width="100"></el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('dev-info-stat:view')" @click="showInfo(scope.row)">详情</el-button>
            <el-button type="text" size="small" v-if="$can('dev-info-stat:edit')" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>
    <div>
      <el-dialog
              title="编辑设备"
              :closeOnClickModal="false"
              :visible.sync="dialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div class="group_27" style="display: flex;">
          <div class="group_28"></div>
          <div class="text_93">基础信息</div>
        </div>
        <div style="margin-left: 15px;  padding: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
          <div style="    min-height: 100px;" v-loading="tableLoading">
            <el-form label-width="100px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="设备号：">
                    {{addInfo.imei}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="ICCID：">
                    {{addInfo.iccid}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="group_27" style="display: flex;">
          <div class="group_28"></div>
          <div class="text_93">编辑信息</div>
        </div>
        <div style="margin-left: 15px;  padding: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
          <div style="    min-height: 100px;" v-loading="tableLoading">
            <el-form :model="addInfo" :rules="rules" ref="addForm" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="设备类型:" prop="type">
                    <el-input v-model="addInfo.type" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="探头数量:" prop="probeCount">
                    <el-input v-model="addInfo.probeCount" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="设置定时：" prop="configuredReportTime">
                    <el-input v-model="addInfo.configuredReportTime" placeholder="间隔小时数" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设备状态:" prop="deviceStatus">
                    <el-select v-model="addInfo.deviceStatus" clearable style="width: 150px;" :disabled="addInfo.deviceStatus =='绑定'" placeholder="请选择">
                      <el-option
                              v-for="(item, i) in deviceStatusList"
                              :key="i"
                              :label="item.value"
                              :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="save">确 定</el-button>
            </div>
          </div>
        </div>


      </el-dialog>
    </div>
    <div>
      <el-dialog
              title="设备详情"
              :visible.sync="infoDialogVisible"
              width="60%"
              :before-close="handleClose"
              center>
        <div class="addInfoStyle">
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">设备信息</div>
            </div>
            <div style="margin-left: 15px;  padding: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
              <div style="    min-height: 100px;" v-loading="tableLoading">
                <el-form label-width="100px">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="ICCID：">
                        {{addInfo.iccid}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="设备号：">
                        {{addInfo.imei}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="主板型号：">
                        {{addInfo.productModel}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="探头数量：">
                        {{addInfo.serialPortNum}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="在用探头：">
                        {{addInfo.inUseNum}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="未用探头：">
                        {{addInfo.serialPortNum - addInfo.inUseNum }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="固件版本：">
                        {{addInfo.softVersion}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="流量：">
                        {{addInfo.dataTraffic}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="探头数：">
                        {{addInfo.probeCount}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="默认时间：">
                        {{addInfo.defaultReportTime}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="设置定时：">
                        {{addInfo.configuredReportTime}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="设备状态：">
                        {{addInfo.deviceStatus}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="bts：">
                        {{addInfo.bts}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="归宿地：">
                        {{addInfo.location}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="电量：">
                        {{addInfo.power}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="创建时间：">
                        {{addInfo.createTime}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="更新时间：">
                        {{addInfo.updateTime}}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="设备类型：">
                        {{addInfo.type}}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    </el-col>
                  </el-row>

                </el-form>
              </div>
            </div>
          </div>
        </div>

      </el-dialog>
    </div>
  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import RichTextEditor from '../util/RichTextEditor';

  export default {
    name: "white-list",
    components: {
      RichTextEditor
    },
    data () {
      // 添加自定义验证规则
      const validateConfiguredReportTime = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入设置定时'));
        }
        const num = parseInt(value);
        if (isNaN(num) || num <= 0 || num % 1 !== 0) {
          callback(new Error('设置定时必须是大于0的整数'));
        } else {
          callback();
        }
      };

      return {
        dialogTitle:'新增设备',
        total:1,
        tableData: [],
        loading: false,
        formLoading: false,
        dialogVisible: false,
        infoDialogVisible: false,
        tableLoading: false,
        currentObjInfo:{},
        searchDateArr:[],
        createDateArr:[],
        deviceStatusList:[],
        currentPage:1,
        roleList:'',
        addInfo:{
          type:'',
          probeCount:'',
          configuredReportTime:'',
          deviceStatus:'',
        },
        searchInfo:{
          iccid:'',
          imei:'',
          deviceStatus:'',
          probeCount:'',
          power:'',
          type:'',
          createDate:'',
          searchDate:'',
          pageNumber:1,
          pageSize:50,
        },
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              //start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }]
        },
        rules: {
          probeCount: [
            { required: true, message: '请输入客户名称', trigger: 'blur' }
          ],
          configuredReportTime: [{ validator: validateConfiguredReportTime, trigger: 'blur' }]
        },
      }
    },
    watch: {
      'searchInfo.iccid'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.imei'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.deviceStatus'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'createDateArr'(newVal,oldVal){
        if (null == newVal){
          this.searchInfo.createDate ="";
          this.pageInfo();
        }
      },
      'searchDateArr'(newVal,oldVal){
        if (null == newVal){
          this.searchInfo.searchDate ="";
          this.pageInfo();
        }
      },
    },
    created: function () {
      this.pageInfo();
      this.getDeviceStatusList();
    },
    methods:{
      search(){
        this.pageInfo();
      },
//改为全局方法
      // 获取编辑器中的内容
      handleContentChange(newContent) {
        this.addInfo.content = newContent;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val ;
        this.pageInfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 0;
        this.searchInfo.pageSize = val ;
        this.pageInfo();
      },
      validate(){
        let flag = true;
        let msg  = "";
        if (this.addInfo.title == ''){
          flag = false;
          msg = "不能为空 "
          return {code:flag,msg:msg}
        }
        return {code:flag,msg:msg}
      },
      save(){
        if (this.formLoading) {
          return;
        }
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.formLoading = true;
            axios.put('/devInfo', this.addInfo).then(result => {
              this.formLoading = false;
              if (result.code === 200) {
                this.$message.success('保存成功');
                this.dialogVisible = false;
                this.pageInfo();
                this.clearObj(this.addInfo);
                this.addInfo.id = undefined;
                this.dialogTitle = "新增设备";
              } else {
                console.error('保存失败，错误码:', result.code, '错误信息:', result.msg);
                this.$message.error(result.msg || '保存失败');
              }
            }).catch(err => {
              console.error('请求发生错误:', err);
              this.formLoading = false;
              this.$message.error('保存失败：' + (err.message || '未知错误'));
            });
          } else {
            console.error('表单验证失败，表单数据:', this.addInfo);
            console.error('表单验证错误:', this.$refs.addForm.fields);
            this.$message.warning('请检查表单填写是否正确');
            return false;
          }
        });
      },
      remove(id){
        axios.delete('/devInfo',{data: {id:id}}).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.pageInfo();
        })
      },
      confirmRemove(id){
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.remove(id);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleClose(done) {
        this.clearObj(this.addInfo); // 清空新增数据
        done();
      },
      showInfo(obj){
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.infoDialogVisible = true;
      },
      handleRowDblClick(row, column, event) {

        this.addInfo =JSON.parse(JSON.stringify(row));
        this.infoDialogVisible = true;
      },
      edit(obj){
        this.dialogTitle = "设备编辑";
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.dialogVisible = true;
      },
      getDeviceStatusList(){
        axios.get('/dict/code',{
          params: {code:101}
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          this.deviceStatusList = result.data;
        }).catch(err => {
          console.log(err);
        });
      },
      pageInfo(){
        if (this.createDateArr !=  null && this.createDateArr != ''){
          this.searchInfo.createDate = this.createDateArr.join('_');
        }
        if (this.searchDateArr !=  null && this.searchDateArr != ''){
          this.searchInfo.searchDate = this.searchDateArr.join('_');
        }


        if (this.loading)  return; // 防止重复提交
        this.loading=true;
        axios.get('/devInfo',{
          params: this.searchInfo
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          let page = result.data;
          this.total = page.total;
          this.tableData = page.list;
        }).catch(err => {
          console.log(err);
          this.loading=false;
        });
      },
    },filters: {
      showState(val){
        if (val == 1){
          return "已处理";
        }
        return "未处理"
      },
      consumerState(val){
        if (val){
          return "禁用";
        }
        return "开启"
      }
    }
  }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    .el-input{
      margin-right: 15px;
      width: 200px;
    }
  }
  /deep/ #contentStyle .el-form-item__content{
    margin-left:0 !important;
  }
  .connectTitleStyle{
    display: flex;
    justify-content: space-between;
    background: #f6f8fc;
    margin-left: 15px;
  }

  /deep/ #connectInfoStyle .el-table{
    .el-table__body-wrapper{
      height: auto; overflow-y: auto;
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;

    .search-form {
      width: 95%;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          padding: 0 8px;
          margin-bottom: 12px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 14px;
            margin-right: 8px;
          }

          .el-input, .el-select {
            width: 150px !important;
          }

          &.date-picker {
            .el-date-editor {
              width: 250px !important;
            }
          }
        }
      }
    }

    .search-btn {
      width: 5%;
      display: flex;
      justify-content: flex-end;
      padding-top: 5px;

      .el-button {
        padding: 12px 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }
  }
</style>
